var _sodipodiNamedview, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompozzBoussoleVioletCentreTrait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    viewBox: "0 0 114 114",
    sodipodiDocname: "Compozz_boussole_violet_centre_trait.svg",
    width: 114,
    height: 114,
    inkscapeVersion: "1.2.2 (b0a8486541, 2022-12-01)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview34",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    showgrid: "false",
    inkscapeZoom: 5.4224638,
    inkscapeCx: 18.441801,
    inkscapeCy: 62.241079,
    inkscapeWindowWidth: 1920,
    inkscapeWindowHeight: 1011,
    inkscapeWindowX: 1920,
    inkscapeWindowY: 32,
    inkscapeWindowMaximized: 1,
    inkscapeCurrentLayer: "Calque_2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, "\n      .cls-1 {\n        fill: #654bf6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1",
    transform: "translate(0.84786445,0.39328387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 36.32,58.67 -3.5,0.7 c -0.51,0.1 -0.95,0.39 -1.23,0.82 -0.29,0.43 -0.39,0.95 -0.29,1.46 0.18,0.88 0.93,1.52 1.82,1.56 h 0.09 c 0.12,0 0.25,-0.01 0.37,-0.04 l 3.49,-0.7 c 1.05,-0.21 1.73,-1.23 1.52,-2.29 -0.21,-1.04 -1.23,-1.76 -2.28,-1.52 z",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 60.54,74.84 c -1.05,0.21 -1.73,1.23 -1.52,2.28 l 0.69,3.49 c 0.17,0.88 0.93,1.52 1.83,1.56 h 0.09 c 0.12,0 0.25,-0.01 0.37,-0.04 1.05,-0.21 1.73,-1.23 1.52,-2.28 l -0.7,-3.49 C 62.61,75.3 61.61,74.65 60.53,74.84 Z",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 80.2,49.91 -3.49,0.7 c -0.51,0.1 -0.95,0.39 -1.23,0.82 -0.29,0.43 -0.39,0.95 -0.29,1.46 0.17,0.88 0.92,1.52 1.82,1.56 h 0.09 c 0.12,0 0.25,-0.01 0.37,-0.04 l 3.49,-0.7 c 1.05,-0.21 1.73,-1.23 1.52,-2.28 -0.21,-1.05 -1.23,-1.74 -2.29,-1.52 z",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 54.06,32.47 c -0.21,-1.05 -1.24,-1.72 -2.28,-1.52 -0.51,0.1 -0.95,0.39 -1.23,0.83 -0.29,0.43 -0.39,0.95 -0.29,1.46 l 0.7,3.5 c 0.17,0.88 0.93,1.52 1.82,1.56 h 0.09 c 0.12,0 0.25,-0.01 0.37,-0.04 0.51,-0.1 0.95,-0.4 1.24,-0.83 0.28,-0.43 0.39,-0.95 0.28,-1.46 z",
    id: "path12"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompozzBoussoleVioletCentreTrait);
export default __webpack_public_path__ + "static/media/Compozz_boussole_violet_centre_trait.cdecef4aff19b5b6386affe3fba96010.svg";
export { ForwardRef as ReactComponent };